<div class="grid grid-cols-12 w-full h-full">
	<div
		class="col-span-5 5xl:col-span-4 flex flex-col items-start overflow-hidden"
	>
		<app-e-signing-view-tab
			class="w-full border-b"
			[(selectedTab_)]="selectedTab_"
		/>
		<div
			class="flex flex-col gap-6 px-6 pt-6 bg-white w-full h-full overflow-y-auto border-r border-gray-200"
		>
			@switch (selectedTab_()) {
				@case (ESigningViewTab.ESIGNING) {
					<app-e-signing-disclaimer />
					<app-e-signing-field-details
						[options]="options_()"
						[(drawOnly_)]="isSignatureDrawOnly_"
						[(selectedBlock_)]="selectedBlock_"
						(dragStart)="onFieldDragStart($event)"
					/>
					<app-e-signing-meta-details
						[avatars]="avatars_()"
						(editSigners)="editSigners_.emit()"
						[envelopeId_]="envelopeId_()"
					/>
				}
				@case (ESigningViewTab.DOCUMENTS) {
					<app-e-signing-package-document-list-details
						[packageId_]="envelopeId_()"
						(documentToRender_)="matterPackageViewModel_.set($event)"
					/>
				}
			}
		</div>
	</div>
	@switch (selectedTab_()) {
		@case (ESigningViewTab.ESIGNING) {
			<app-e-signing-canvas
				[pages]="pages_()"
				[eSigningBlocks]="eSigningBlocks_()"
				[recipients]="recipients_()"
				[pendingBlock]="pendingBlock_()"
				[pendingDragBlock]="pendingDragBlock_()"
				(eSigningBlockChange)="eSigningBlockChange.emit($event)"
				(blockPlaced)="onBlockPlacedViaDrag()"
				[isLoading]="isSnapshotting_()"
				class="col-span-7 w-full h-full 5xl:col-span-8"
			/>
		}
		@case (ESigningViewTab.DOCUMENTS) {
			<app-matter-package-preview
				[form_]="matterPackageViewModel_().form"
				[docxPreviewDocId_]="matterPackageViewModel_().docxPreviewDocId"
				[uploadedDocPreviewSourcePath_]="
					matterPackageViewModel_().uploadedDocPreviewSourcePath
				"
				[hasNoContents_]="!hasDocumentToRender_()"
				class="col-span-7 w-full h-full 5xl:col-span-8"
			/>
		}
	}
</div>
